import React, { useState } from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "src/store/hooks";
import { selectServerPlanEntities, selectServerPlanIds } from "src/store/mine_craft/serverPlansSlice";

import Card from "../../ServerPlans/_partials/_Card";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";

// Reference popup for the Plan select: the same cards as the plans
// page, without the edit actions.
const _PlansHelp = () => {
  const [open, setOpen] = useState(false);
  const ids   = useAppSelector(selectServerPlanIds);
  const plans = useAppSelector(selectServerPlanEntities);

  const renderPlan = (id: EntityId) => {
    const plan = plans[id];

    if (!plan) {
      return null;
    }

    return <Card key={`plan-help-${id}`} plan={plan} showActions={false} />;
  }

  return (
    <>
      <button
        type='button'
        className='v-plans-help'
        title='Show all plans'
        onClick={() => setOpen(true)}
      >
        <QuestionCircleOutlined />
      </button>

      <Modal
        open={open}
        title='Server plans'
        width={820}
        footer={null}
        zIndex={1200}
        onCancel={() => setOpen(false)}
      >
        <div className='v-plan-cards'>
          {ids && ids.map(renderPlan)}
        </div>
      </Modal>
    </>
  );
}

export default _PlansHelp;
